import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class PessoaResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  listPessoaFisica(search) {
    const paramslist = {
      page: 1,
      sortBy: 'nome',
      sortDesc: false,
      itemsPerPage: -1,
      searchBy: null,
      searchJoinAnd: true,
      filterBy: 'id;nome;cpf_cnpj;tipo',
    };
    paramslist.searchBy = `nome:${search};tipo:P`;
    return this.search(paramslist);
  }

  listPessoaJuridica(search) {
    const paramslist = {
      page: 1,
      sortBy: 'nome',
      sortDesc: false,
      itemsPerPage: -1,
      searchBy: null,
      searchJoinAnd: true,
      filterBy: 'id;nome;cpf_cnpj;tipo',
    };
    paramslist.searchBy = `nome:${search};tipo:J`;
    return this.search(paramslist);
  }

  listPessoa(search) {
    const paramslist = {
      page: 1,
      sortBy: 'nome',
      sortDesc: false,
      itemsPerPage: -1,
      searchBy: null,
      searchJoinAnd: false,
      filterBy: 'id;nome;cpf_cnpj',
    };
    if (search) {
      paramslist.searchBy = `nome:${search};cpf_cnpj:${search}`;
    }
    return this.search(paramslist);
  }

  consulta(params) {
    return this.http.post(`${this.resource}/consulta`, params);
  }

  uploadFoto(params) {
    return this.http.post(`${this.resource}/upload_foto`, params);
  }

  checkDocumento(params) {
    return this.http.post(`${this.resource}/check_documento`, params);
  }

  destroyFile(id) {
    return this.http.delete(`${this.resource}/${id}/destroy_file`);
  }
}

const resource = 'pessoa';

const pessoaHttp = new PessoaResourceHttp(clientHttp, prefixBase + resource);

export default pessoaHttp;
